<script>
export default {
  methods: {
    $can: function (permissionName) {
      const permissionString = this.$store.state.user?.permissions;
      if (!permissionString) {
        return false;
      }
      const userPermissions = JSON.parse(permissionString);
      return userPermissions.includes(permissionName);
    },
  },
};
</script>
